import { type DescriptionListData } from 'src/components/elements';

import type { IExpandableCopyProps } from '../ExpandableCopy';
import {
  StyledDescriptionList,
  StyledExpandableCopy,
  StyledHeadline,
  StyledWrapper,
} from './About.styled';

export interface IAboutProps {
  className?: string;
  headline: string;
  descriptionList: DescriptionListData[];
  copy: string;
  expandButtonLabels: IExpandableCopyProps['buttonLabels'];
}

export const About = ({
  className,
  headline,
  descriptionList,
  copy,
  expandButtonLabels,
}: IAboutProps) => (
  <StyledWrapper
    className={className}
    width={{ laptop: 'l', tabletLandscape: 'm' }}
  >
    <StyledHeadline forwardedAs="h2" size="h3" label={headline} />
    <StyledDescriptionList data={descriptionList} variant="secondary" />
    <StyledExpandableCopy
      text={copy}
      buttonLabels={expandButtonLabels}
      lines={5}
    />
  </StyledWrapper>
);
